// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3W5nC","rightAdornment":"Header_rightAdornment__1OjgG"};